import api, { createAuthenticatedApi } from '../api';
// import { useAuth } from '../context/AuthContext';
// const userGroups = useAuth();
// console.log('User Groups logtContent:', userGroups?.userData);
const endpoint = 'logt';
const Airlinepoint = 'aircrafts/get?id=';

export const fetchLogTContentById = async (
    id: number,
    accessToken?: string,
    useExtendedSearchApi: boolean = false
) => {
    try {
        const apiClient = accessToken ? createAuthenticatedApi(accessToken) : api;
        const detailEndpoint = useExtendedSearchApi ? `${endpoint}/extended/${id}` : `${endpoint}/${id}`;
        const response = await apiClient.get(detailEndpoint);
        return response.data;
    } catch (error: any) {
        throw new Error(`Failed to fetch log content with ID ${id}: ` + error.message);
    }
};
export const fetchAirlineByAirline = async (id: string, accessToken?: string) => {
    try {
        const apiClient = accessToken ? createAuthenticatedApi(accessToken) : api;
        const response = await apiClient.get(`${Airlinepoint}${id}`);
        return response.data;
    } catch (error: any) {
        throw new Error(`Failed to fetch log content with ID ${id}: ` + error.message);
    }
};
